export default __webpack_public_path__ + "static/media/neetjeerepeaterhindi.55d4425d.png";